import { useEffect, useState, useRef } from "react";
import Tooltip from "../../components/popups/Tooltip";
import './TruncatedString.scss'

const TruncatedString = (props) => {
	const { string, delay, buffer, maxWidth, stringStyle, maxWidthFunction } = props
	const [isOverflown, setIsOverflown] = useState(false);
	const textElementRef = useRef();

	const compareSize = () => {
		const element = textElementRef.current;
		if (element) {
			//console.log("# Comparing maxWidth:", maxWidth);
			const parent = element.offsetParent
			const compare = maxWidthFunction ? maxWidthFunction(parent, element) : maxWidth ? element.offsetWidth > maxWidth : element.offsetWidth + (buffer || buffer === 0 ? buffer : 20) > parent.offsetWidth;
			setIsOverflown(compare);
		}
	};

	useEffect(() => {
		compareSize()
		textElementRef.current && textElementRef.current.addEventListener('mouseover', compareSize());
		window.addEventListener('mouseover', compareSize)

		return () => {
			textElementRef.current && textElementRef.current.removeEventListener('mouseover', compareSize());
			window.removeEventListener('mouseover', compareSize);
		}
	}, [textElementRef]);


	return (
		<Tooltip delay={delay} placement="top-start" offsetY={8} label={string} disabled={!isOverflown} truncate>
			<div className="truncated-string" style={stringStyle} ref={textElementRef}>{string}</div>
		</Tooltip>
	)
}

export default TruncatedString